// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:10
import { GeoFenceRequestResult_abstract } from './../abstract/SagaBase/GeoFenceRequestResult_abstract';
export class GeoFenceRequestResult extends GeoFenceRequestResult_abstract {}
